import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("softeis_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const path = window.location.pathname;
            if (path.startsWith("/admin") && path !== "/admin/login") {
                localStorage.removeItem("softeis_admin_token");
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

export const fileUrl = (urlOrPath) => {
    if (!urlOrPath) return "";
    if (urlOrPath.startsWith("http")) return urlOrPath;
    if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
    return urlOrPath;
};

export default api;
